import { computeCuveCost } from './cuveCalculations.js';
import { computePompageCost } from './pompageCalculations.js';
import { computeFiltrationCost } from './filtrationCalculations.js';
import { computePlomberieCost } from './plomberieCalculations.js';

export { cuveCost, CUVE_TIERS, mainOeuvreCost } from './cuveCalculations.js';
export { SURPRESSION_TABLE } from './pompageCalculations.js';
export { FILTRATION_MODULES } from './filtrationCalculations.js';
export { plomberieCost, EXTRAS_COST, PLOMBERIE_LABELS } from './plomberieCalculations.js';

export const fmtEUR = (n) => Math.round(n).toLocaleString('fr-FR');

/**
 * Composeur : fusionne les 4 domaines de chiffrage (cuve, pompage, filtration, plomberie)
 * en un seul breakdown + total. Chaque domaine est calculé indépendamment par sa propre
 * fonction pure ; ce fichier ne fait qu'assembler le résultat.
 * @param {Object} budgetState - { cuve, pompage, filtration, plomberie }
 */
export const computeBudget = (budgetState) => {
  const cuve = computeCuveCost(budgetState.cuve);
  const pompage = computePompageCost(budgetState.pompage);
  const filtration = computeFiltrationCost(budgetState.filtration);
  const plomberie = computePlomberieCost(budgetState.plomberie);

  const breakdown = [...cuve.breakdown, ...pompage.breakdown, ...filtration.breakdown, ...plomberie.breakdown];
  const totalLow = cuve.low + pompage.low + filtration.low + plomberie.low;
  const totalHigh = cuve.high + pompage.high + filtration.high + plomberie.high;

  return { breakdown, totalLow, totalHigh };
};
